import {
  canSeeTwelveMonthsImpact,
  canViewFreeImpactReport,
} from 'javascripts/analytics/config/permissions';
import _ from 'underscore';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
import React from 'react';
import moment from 'moment';
import { withRouter } from 'react-router-dom';

import { TwelveMonthImpactReportContainer } from './twelve_month_impact_report_container';
import { ImpactTabContainer } from './impact_tab_container';

export const SwitchableImpactTabContainer = withRouter(
  // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
  // eslint-disable-next-line react/display-name
  class extends React.Component {
    static propTypes = {
      router: PropTypes.object.isRequired,
    };

    getStateFromStore = () => {
      return {
        displayedDates:
          Aedu.ReduxStore.getState().AnalyticsDashboard.DisplayedDates,
        impactAggregations:
          Aedu.ReduxStore.getState().AnalyticsDashboard.ImpactAggregations,
      };
    };

    componentDidMount() {
      this.unsubscribe = Aedu.ReduxStore.subscribe(
        function () {
          this.setState(this.getStateFromStore());
        }.bind(this),
      );
    }

    componentWillUnmount() {
      this.unsubscribe();
    }

    render() {
      const { relPath } = this;
      return (
        <div>
          {!!(canSeeTwelveMonthsImpact || canViewFreeImpactReport) && (
            <div className="u-mt3x u-mb8x u-ph4x clearfix">
              {this.impactDurationHeader()}
            </div>
          )}

          <Route exact path={relPath('/')} component={ImpactTabContainer} />
          <Route
            path={relPath('/12month')}
            component={TwelveMonthImpactReportContainer}
          />
        </div>
      );
    }

    relPath = (path) => {
      if (path[0] !== '/') {
        return this.props.match.url + '/' + path;
      }
      return this.props.match.url + path;
    };

    impactDurationHeader = () => {
      if (!(this.startDate().isValid() && this.endDate().isValid())) {
        return null;
      }

      const formatDate = _.bind(I18n.l, I18n, 'date.formats.long');
      return (
        <span className="u-fs16 u-lineHeight2">
          <span className="u-tcGrayDarkest u-fw700">
            {I18n.t('analytics_dashboard.impact_tab.your_impact')}
          </span>{' '}
          {I18n.t('analytics_dashboard.impact_tab.from_date_range', {
            startDate: formatDate(this.startDate().toDate()),
            endDate: formatDate(this.endDate().toDate()),
          })}
        </span>
      );
    };

    startDate = () => {
      if (this.props.location.pathname === '/activity/impact/12month') {
        //Use the date that 12 months impact report was last calculated for (This data is returned by the server)
        return moment(
          Aedu.ReduxStore.getState().AnalyticsDashboard.ImpactAggregations
            .aggregations.startsOn,
        );
      } else {
        return moment(
          Aedu.ReduxStore.getState().AnalyticsDashboard.DisplayedDates.start,
        );
      }
    };

    endDate = () => {
      if (this.props.location.pathname === '/activity/impact/12month') {
        //Use the date that 12 months impact report was last calculated for (This data is returned by the server)
        return moment(
          Aedu.ReduxStore.getState().AnalyticsDashboard.ImpactAggregations
            .aggregations.finishesOn,
        );
      } else {
        return moment(
          Aedu.ReduxStore.getState().AnalyticsDashboard.DisplayedDates.finish,
        );
      }
    };

    prettyDate = (date) => {
      return date.format('MMMM D, YYYY');
    };

    state = this.getStateFromStore();
  },
);
